import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { AbsenceListItem } from 'src/app/core/models/client-models';
import { TableColumn } from '../../../../core/models/table-column';

@Component({
  selector: 'app-absence-selection-list-item',
  templateUrl: './absence-selection-list-item.component.html',
  styleUrls: ['./absence-selection-list-item.component.scss'],
})
export class AbsenceSelectionListItemComponent implements OnInit {
  @Input() absenceList$: Observable<AbsenceListItem[]>;
  @Input() tableColumns$: Observable<TableColumn[]>;
  @Input() selectedIndex$: Observable<number>;

  @Output() onClickEvent = new EventEmitter<AbsenceListItem>();
  @Output() onHoverEvent = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onHover(index: number) {
    this.onHoverEvent.emit(index);
  }

  onClick(row: AbsenceListItem) {
    this.onClickEvent.emit(row);
  }
}
